import * as TK from 'components/search/Result/translations/constants';
import { Translations } from 'translations/types';

export const resultEnUsLocale: Translations = {
  [TK.RESULT_FOR]: 'Result for',
  [TK.RESULT_PROFILES_TAB_LABEL]: 'Profiles',
  [TK.RESULT_POSTS_TAB_LABEL]: 'Posts',
};
